@if (!isResponse) {
<!-- Rows Configuration -->
<div class="row-config-section mb-4">
  <div class="section-header mb-3">
    <mat-icon>view_stream</mat-icon>
    <span>{{ "generic.rows" | translate | titlecase }}</span>
  </div>
  <div cdkDropList (cdkDropListDropped)="dropRow($event)" class="drag-list px-0 bg-transparent border-0">
    @for (row of displayRows; track row; let i = $index) {
    <div class="option-row shadow-sm mb-3 rounded bg-white d-flex align-items-center" cdkDrag>
      <!-- Visual Handle -->
      <div class="drag-handle-grid mr-3" cdkDragHandle>
        <mat-icon>drag_indicator</mat-icon>
      </div>

      <div class="flex-grow-1 d-flex align-items-center">
        <div class="option-input-wrapper w-100">
          <input type="text" [disabled]="!editable" class="option-text-input" [(ngModel)]="displayRows[i].title"
            placeholder="Row Label">
        </div>
      </div>

      @if (displayRows.length > 2 && editable) {
      <button mat-icon-button class="delete-option-btn ml-2" (click)="removeRow(i)">
        <mat-icon>close</mat-icon>
      </button>
      }

      <!-- Preview HELPER for Drag -->
      <div *cdkDragPreview class="cdk-drag-preview p-3 border rounded shadow bg-white d-flex align-items-center">
        <mat-icon class="mr-3 text-muted">drag_indicator</mat-icon>
        <span>{{ row.title }}</span>
      </div>
      <div *cdkDragPlaceholder class="cdk-drag-placeholder"></div>
    </div>
    }
  </div>
  @if (editable) {
  <div class="mt-2">
    <button mat-button class="add-option-btn" (click)="addRow()">
      <mat-icon>add</mat-icon> {{ "pages.survey-details.add-row" | translate }}
    </button>
  </div>
  }
</div>

<!-- Columns Configuration -->
<div class="column-config-section mb-4">
  <div class="section-header mb-3">
    <mat-icon>view_column</mat-icon>
    <span>{{ "generic.columns" | translate | titlecase }}</span>
  </div>
  <div cdkDropList (cdkDropListDropped)="dropColumn($event)" class="drag-list px-0 bg-transparent border-0">
    @for (col of displayColumns; track col; let j = $index) {
    <div class="option-row shadow-sm mb-3 rounded bg-white d-flex align-items-center" cdkDrag>
      <!-- Visual Handle -->
      <div class="drag-handle-grid mr-3" cdkDragHandle>
        <mat-icon>drag_indicator</mat-icon>
      </div>

      <div class="flex-grow-1 d-flex align-items-center">
        <div class="option-input-wrapper w-100">
          <input type="text" [disabled]="!editable" class="option-text-input" [(ngModel)]="displayColumns[j].title"
            placeholder="Column Label">
        </div>
      </div>

      @if (displayColumns.length > 2 && editable) {
      <button mat-icon-button class="delete-option-btn ml-2" (click)="removeColumn(j)">
        <mat-icon>close</mat-icon>
      </button>
      }

      <!-- Preview HELPER for Drag -->
      <div *cdkDragPreview class="cdk-drag-preview p-3 border rounded shadow bg-white d-flex align-items-center">
        <mat-icon class="mr-3 text-muted">drag_indicator</mat-icon>
        <span>{{ col.title }}</span>
      </div>
      <div *cdkDragPlaceholder class="cdk-drag-placeholder"></div>
    </div>
    }
  </div>
  @if (editable) {
  <div class="mt-2">
    <button mat-button class="add-option-btn" (click)="addColumn()">
      <mat-icon>add</mat-icon> {{ "pages.survey-details.add-column" | translate }}
    </button>
  </div>
  }
</div>
}

@if (isResponse && displayedColumns) {
<div class="table-wrapper">
  <table mat-table [dataSource]="displayRows" class="full-width">
    <!-- Question Column -->
    <ng-container matColumnDef="rowID">
      <th mat-header-cell *matHeaderCellDef sticky class="col-question">{{ "generic.question" | translate }}</th>
      <td mat-cell *matCellDef="let row" class="col-question">{{ row.title }}</td>
    </ng-container>

    <!-- Dynamic Columns -->
    @for (column of displayColumns; track column) {
    <ng-container [matColumnDef]="column.id">
      <th mat-header-cell *matHeaderCellDef sticky>{{ column.title }}</th>
      <td mat-cell *matCellDef="let row" fxLayoutAlign="center">
        <mat-radio-group [(ngModel)]="row.answer_id" (ngModelChange)="onAnswerChange(row)" name="row_{{ row.id }}">
          <mat-radio-button [value]="column.id" [disabled]="!editable && !isResponse"></mat-radio-button>
        </mat-radio-group>
      </td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row-hover"></tr>
  </table>
</div>
}
